import React, { useContext, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { createPollEventHandlers } from './pollEventHandlers';
import { useServerPolling } from './useServerPolling';

const ServerPollingGate = () => {
    const { appConfiguration } = useContext(AppContext);
    const { logout } = useAuth0();
    const { doAction } = useDataProvider('auth/user');

    const enabled =
        Boolean(localStorage.getItem('token')) && Boolean(appConfiguration?.app?.polling);
        
    const handlers = useMemo(
        () => createPollEventHandlers({ appConfiguration, logout, doAction }),
        [appConfiguration, logout, doAction]
    );

    useServerPolling({ enabled, handlers });

    return null;
};

export default ServerPollingGate;

